import { apiHolder, apis } from 'api';
import { getTreeId2Node, getFolderErrorMsg, getTreeIdPathById, getMapConfigBySameAccountKey, isMainAccount, getMailFolderTreeList, getTreeStatesByAccount, getWmGuideSortFoldeIds, } from '../../../util';
import { thunkHelperFactory, reduxMessage } from '@web-common/utils/redux_utils';
import { folderOperErrCode2Msg, filterNotMainFolder } from '../../customize';
import { MailTabActions } from '@web-common/state/reducer';
import { defaultTreeState } from './mailReducer';
import { cloneDeep } from 'lodash';
import { FOLDER_EXPAND_ACCOUNT } from '@web-mail/common/constant';
import { getIn18Text } from 'api';
import { getStateFromLocalStorage } from '@web-mail/hooks/useUserLocalStorageState';
import { mergeAllFolderList } from '@web-mail/state/customize/folder';
import { treeDFS } from '@web-mail/util';
const ReducerName = 'MailReducer';
const Thunks = {};
const ReducersList = [];
const thunkHelper = thunkHelperFactory(ReducerName, Thunks, ReducersList);
const MailApis = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const mailConfApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
const systemApi = apiHolder.api.getSystemApi();
let allSubAccountsCache = {
    data: [],
    time: 0,
};
thunkHelper({
    name: 'refreshFolder',
    request: async (params, thunkAPI) => {
        const { noCache = false, account = '', from } = params || {};
        const { dispatch, rejectWithValue } = thunkAPI;
        MailApis.syncSubActions();
        const allAccounts = await accountApi.getMainAndSubAccounts();
        if (allAccounts) {
            let moreAccounts = [];
            if (allSubAccountsCache.data && allSubAccountsCache.data.length) {
                const allAccountsAgentEmail = allAccounts.map(account => account.agentEmail);
                moreAccounts = allSubAccountsCache.data.filter((a) => !allAccountsAgentEmail.includes(a.agentEmail));
            }
            if (moreAccounts && moreAccounts.length && !noCache) {
                try {
                    await dispatch(Thunks.refreshFolderByAccountsNew({ noCache, accounts: [...allAccounts, ...moreAccounts], from }));
                }
                catch (e) {
                    console.error('[error] Thunks.refreshFolderByAccountsNew', e);
                }
            }
            else {
                try {
                    await dispatch(Thunks.refreshFolderByAccountsNew({ noCache, accounts: [...allAccounts], from }));
                }
                catch (e) {
                    console.error('[error] Thunks.refreshFolderByAccountsNew', e);
                }
            }
            try {
                dispatch(Thunks.doListMailBoxByAccountIds({}));
            }
            catch (e) {
                console.error('[error] Thunks.doListMailBoxByAccountIds', e);
            }
            let allSubAccountsFromServer = [];
            if (!noCache && allSubAccountsCache.data && allSubAccountsCache.data.length && Date.now() - allSubAccountsCache.time < 3600000) {
                allSubAccountsFromServer = allSubAccountsCache.data;
            }
            else {
                allSubAccountsFromServer = await accountApi.getAllSubAccounts();
                accountApi.subAccountsSyncLogin(allSubAccountsFromServer);
                accountApi.deleteLocalSubAccountsByServerAccounts(allSubAccountsFromServer, allAccounts);
                allSubAccountsCache = {
                    data: allSubAccountsFromServer || [],
                    time: Date.now(),
                };
            }
            if (allSubAccountsFromServer) {
                const allAccountsAgentEmail = allAccounts.map(a => a.agentEmail);
                const moreAccounts = allSubAccountsFromServer.filter(a => !allAccountsAgentEmail.includes(a.agentEmail));
                if (moreAccounts && moreAccounts.length) {
                    try {
                        await dispatch(Thunks.refreshFolderByExpiredAccounts({ accounts: [...moreAccounts] }));
                    }
                    catch (e) {
                        console.error('[error] refreshFolderByExpiredAccounts', e);
                    }
                }
            }
        }
    },
    fulfilled: (state, action) => { },
    rejected: (state, action) => {
        console.error('[refreshFolder Error]', action);
    },
});
thunkHelper({
    name: 'doListMailBoxByAccountIds',
    request: async (params) => {
        const {} = params || {};
        const allAccounts = await accountApi.getMainAndSubAccounts({ expired: false });
        const allAccountIds = allAccounts.map(account => account.id);
        if (allAccountIds.length > 1) {
            const res = await MailApis.doListMailBoxByAccountIds(true, allAccountIds);
            return { res, allAccountIds };
        }
        return { res: [], allAccountIds };
    },
    fulfilled: (state, action) => {
        const { res, allAccountIds } = action.payload || {};
        const resKeys = Object.keys(res);
        if (res && resKeys.length < allAccountIds.length) {
            const needAccountIds = allAccountIds.filter((accountId) => !resKeys.includes(accountId));
            state.AllFolderData = mergeAllFolderList(res, state.otherClusterNode, needAccountIds);
        }
        else {
            if (res) {
                state.AllFolderData = mergeAllFolderList(res, state.otherClusterNode);
            }
        }
    },
    rejected: (state, action) => {
        console.log(action);
    },
});
thunkHelper({
    name: 'refreshFolderByAccountsNew',
    pending: (state, action) => {
        const { accounts } = action.meta.arg || {};
        const treeMap = {};
        accounts.forEach((account, idx) => {
            const accountId = !account.isSubAccount || account.accountType === 'mainAccount' ? 'main' : account.agentEmail || account.accountEmail || account.id;
            if (!Object.keys(state.mailTreeStateMap).includes(accountId)) {
                treeMap[accountId] = {
                    mailFolderTreeList: [],
                    MailFolderTreeMap: {},
                    sort: idx,
                    accountId: account.agentEmail,
                    accountName: account.agentEmail,
                    emailType: account.emailType,
                    expired: false,
                    hasCustomFolder: false,
                    mailTagList: [],
                    expandedKeys: [],
                    allReadLoadingMap: {},
                    initLoading: true,
                };
            }
        });
        state.mailTreeStateMap = Object.assign(Object.assign({}, state.mailTreeStateMap), treeMap);
    },
    request: async (params, thunkAPI) => {
        const { noCache = false, accounts = [], from } = params || {};
        const { dispatch } = thunkAPI;
        dispatch(Thunks.refreshFolderByAccountsNewDetele({ accounts }));
        await Promise.allSettled(accounts.map(async (account, index) => {
            return dispatch(Thunks.refreshFolderBySingleAccount({ noCache, account: account, from, index }));
        }));
    },
    fulfilled: (state, action) => { },
    rejected: (state, action) => { },
});
thunkHelper({
    name: 'refreshFolderByAccountsNewDetele',
    request: async (params, thunkAPI) => {
        const { accounts = [] } = params || {};
        return accounts;
    },
    fulfilled: (state, action) => {
        const accounts = action.payload || {};
        if (accounts) {
            const treeMap = Object.assign({}, state.mailTreeStateMap);
            const treeMapKeys = Object.keys(treeMap);
            const accountIds = accounts.map(accountInfo => {
                const { agentEmail, id, accountEmail, isSubAccount, accountType } = accountInfo;
                if (!isSubAccount || accountType === 'mainAccount') {
                    return 'main';
                }
                else {
                    return agentEmail || accountEmail || id;
                }
            });
            const needDeleteKeys = treeMapKeys.filter(id => !accountIds.includes(id));
            if (needDeleteKeys && needDeleteKeys.length) {
                needDeleteKeys.forEach(id => {
                    if (id !== 'main') {
                        delete treeMap[id];
                    }
                });
                state.mailTreeStateMap = treeMap;
            }
        }
    },
    rejected: (state, action) => { },
});
thunkHelper({
    name: 'refreshFolderBySingleAccount',
    pending: (state, action) => {
        const { account, noCache } = action.meta.arg || {};
        if (!!noCache) {
            if (state.mailTreeNetworkLoadingMap && state.mailTreeNetworkLoadingMap[account === null || account === void 0 ? void 0 : account.id]) {
                return;
            }
            state.mailTreeNetworkLoadingMap = Object.assign(Object.assign({}, state.mailTreeNetworkLoadingMap), { [account === null || account === void 0 ? void 0 : account.id]: true });
        }
        else {
            if (state.mailTreeLocalLoadingMap && state.mailTreeLocalLoadingMap[account === null || account === void 0 ? void 0 : account.id]) {
                return;
            }
            state.mailTreeLocalLoadingMap = Object.assign(Object.assign({}, state.mailTreeLocalLoadingMap), { [account === null || account === void 0 ? void 0 : account.id]: true });
        }
    },
    request: async (params) => {
        const { noCache = false, account = {}, from, index } = params || {};
        if (account.expired) {
            return { res: [[account, [], index]] };
        }
        else {
            const resultPromise = new Promise(resolve => {
                MailApis.doListMailBox(noCache, undefined, from, account.id)
                    .then(res => {
                    resolve(res);
                })
                    .catch(() => {
                    resolve([]);
                });
            });
            const result = await resultPromise;
            return { res: [[account, result, index]] };
        }
    },
    fulfilled: (state, action) => {
        const { res } = action.payload || {};
        if (res) {
            const account = res[0][0];
            const treeMap = Object.assign({}, state.mailTreeStateMap);
            const { mailTreeStateMap, loginingSubAccountList } = state;
            const expiredAccountList = [];
            res.forEach((cres) => {
                const [accountInfo, value, index] = cres;
                if (accountInfo && accountInfo.expired) {
                    expiredAccountList.push(accountInfo.agentEmail);
                }
                const accountId = accountInfo.agentEmail || accountInfo.id;
                if (accountInfo && !accountInfo.expired && loginingSubAccountList.includes(accountId)) {
                    state.loginingSubAccountList = state.loginingSubAccountList.filter(item => item !== accountId);
                }
                if (!!value.length) {
                    const accountId = !accountInfo.isSubAccount || accountInfo.accountType === 'mainAccount' ? 'main' : accountInfo.agentEmail || accountInfo.accountEmail || accountInfo.id;
                    let folderList = value;
                    if (!!accountInfo.isSubAccount) {
                        folderList = filterNotMainFolder(value);
                    }
                    if (folderList) {
                        const oldTreeMap = getMapConfigBySameAccountKey(mailTreeStateMap, accountId) || cloneDeep(defaultTreeState);
                        treeMap[accountId] = Object.assign(Object.assign({}, oldTreeMap), { mailFolderTreeList: folderList, MailFolderTreeMap: getTreeId2Node(folderList), sort: index, accountId: accountInfo.agentEmail, accountName: accountInfo.agentEmail, emailType: accountInfo.emailType, expired: accountInfo.expired, hasCustomFolder: (() => {
                                let found = false;
                                treeDFS(folderList, (item) => {
                                    var _a;
                                    if (Number((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId) >= 100) {
                                        found = true;
                                    }
                                });
                                return found;
                            })(), initLoading: false });
                        try {
                            const folderExpandAccounts = getStateFromLocalStorage(FOLDER_EXPAND_ACCOUNT);
                            if (folderExpandAccounts && folderExpandAccounts[accountId] && treeMap[accountId]) {
                                treeMap[accountId].expandedKeys = folderExpandAccounts[accountId];
                            }
                        }
                        catch (e) {
                            console.error('[Error refreshFolderBySingleAccount  FOLDER_EXPAND_ACCOUNT]', e);
                        }
                    }
                }
            });
            state.expiredAccountList = expiredAccountList;
            const treeMapKeys = Object.keys(treeMap);
            if (treeMapKeys.length) {
                state.mailTreeStateMap = treeMap;
            }
            state.mailTreeNetworkLoadingMap[account.id] = false;
            state.mailTreeLocalLoadingMap[account.id] = false;
        }
    },
    rejected: (state, action) => {
        console.log(action);
        const { res } = action.payload || {};
        const account = res[0][0];
        state.mailTreeNetworkLoadingMap[account.id] = false;
        state.mailTreeLocalLoadingMap[account.id] = false;
    },
});
thunkHelper({
    name: 'refreshFolderByExpiredAccounts',
    request: async (params) => {
        const { accounts = [] } = params || {};
        const treeList = await Promise.allSettled(accounts.map(account => {
            return Promise.resolve([]);
        }));
        return { res: accounts.map((accountInfo, idx) => [accountInfo, treeList[idx]]) };
    },
    fulfilled: (state, action) => {
        const { res } = action.payload || {};
        if (res) {
            const treeMap = {};
            const { mailTreeStateMap } = state;
            const expiredAccountList = [];
            res.forEach((cres, idx) => {
                const [accountInfo, value] = cres;
                if (accountInfo) {
                    expiredAccountList.push(accountInfo.agentEmail);
                }
                const treeMapKeyLength = Object.keys(mailTreeStateMap).length;
                if (value.status === 'fulfilled') {
                    const accountId = accountInfo.agentEmail || accountInfo.accountEmail || accountInfo.id;
                    if (idx > 0 && (value === null || value === void 0 ? void 0 : value.value) && (value === null || value === void 0 ? void 0 : value.value.length)) {
                        value.value = filterNotMainFolder(value.value);
                    }
                    if (value === null || value === void 0 ? void 0 : value.value) {
                        const oldTreeMap = getMapConfigBySameAccountKey(mailTreeStateMap, accountId) || cloneDeep(defaultTreeState);
                        treeMap[accountId] = Object.assign(Object.assign({}, oldTreeMap), { mailFolderTreeList: [], MailFolderTreeMap: {}, sort: treeMapKeyLength + idx, accountId: accountInfo.agentEmail, accountName: accountInfo.agentEmail, emailType: accountInfo.emailType, expired: true, hasCustomFolder: false });
                        try {
                            const folderExpandAccounts = getStateFromLocalStorage(FOLDER_EXPAND_ACCOUNT);
                            if (folderExpandAccounts && folderExpandAccounts[accountId] && treeMap[accountId]) {
                                treeMap[accountId].expandedKeys = folderExpandAccounts[accountId];
                            }
                        }
                        catch (e) {
                            console.error('[Error refreshFolderByExpiredAccounts  FOLDER_EXPAND_ACCOUNT]', e);
                        }
                    }
                }
            });
            state.expiredAccountList = [...new Set([...state.expiredAccountList, ...expiredAccountList])];
            state.mailTreeStateMap = Object.assign(Object.assign({}, mailTreeStateMap), treeMap);
        }
    },
    rejected: (state, action) => {
        console.log(action);
    },
});
thunkHelper({
    name: 'createUserFolder',
    request: async (params, thunkAPI) => {
        var _a;
        const { dispatch, rejectWithValue } = thunkAPI;
        const accountId = params && params.length ? (_a = params[0]) === null || _a === void 0 ? void 0 : _a.accountId : undefined;
        const folder = params.map(item => {
            const { parent, name } = item;
            return {
                name,
                parent: parent >= 0 ? parent : 0,
            };
        });
        const res = await MailApis.createUserFolder(folder, { syncMailFolder: false }, accountId);
        try {
            const sortParams = [];
            params.forEach((item, index) => {
                const { parent, sort, _tempId } = item;
                const readFid = res[index];
                let sorts = sort.join(',').replace(_tempId + '', readFid + '');
                if (sort && readFid) {
                    sortParams.push({
                        id: parent >= 0 ? parent : 0,
                        sorts: sorts,
                    });
                }
            });
            await MailApis.updateUserFolder(sortParams, accountId);
        }
        catch (e) {
            console.log('[createUserFolder - sort] error');
        }
        if (res) {
            dispatch(Thunks.refreshFolder({ noCache: true, account: accountId }));
            return { params, res };
        }
        return rejectWithValue();
    },
    fulfilled: () => {
    },
    rejected: (state, action) => {
        const errorMsg = getFolderErrorMsg(action.error) || getIn18Text('CHUANGJIANWENJIANJIA');
        reduxMessage.error({ content: errorMsg });
    },
});
thunkHelper({
    name: 'updateUserFolder',
    request: async (params, thunkAPI) => {
        var _a, _b;
        const { dispatch, rejectWithValue } = thunkAPI;
        const accountId = (_b = (_a = params[0]) === null || _a === void 0 ? void 0 : _a.accountId) !== null && _b !== void 0 ? _b : null;
        const folder = params.map(item => (Object.assign(Object.assign({}, item), { parent: typeof item.parent === 'number' ? item.parent : 0, accountId: undefined })));
        const res = await MailApis.updateUserFolder(folder, accountId);
        if (res) {
            dispatch(Thunks.refreshFolder({ noCache: true, account: accountId }));
            return { params, res };
        }
        return rejectWithValue();
    },
    fulfilled: () => {
    },
    rejected: (state, action) => {
        const errorMsg = getFolderErrorMsg(action.error) || getIn18Text('GENGXINWENJIANJIA');
        reduxMessage.error({ content: errorMsg });
    },
});
thunkHelper({
    name: 'moveUserFolder',
    request: async (params, thunkAPI) => {
        var _a;
        const { dispatch, rejectWithValue } = thunkAPI;
        const accountId = params && params.length ? (_a = params[0]) === null || _a === void 0 ? void 0 : _a.accountId : null;
        const folder = params.map(item => (Object.assign(Object.assign({}, item), { parent: typeof item.parent === 'number' ? item.parent : 0 })));
        const res = await MailApis.updateUserFolder(folder, accountId);
        if (res) {
            dispatch(Thunks.refreshFolder({ noCache: true, account: accountId }));
            return { params, res };
        }
        return rejectWithValue();
    },
    fulfilled: () => {
    },
    rejected: (state, action) => {
        const errorMsg = getFolderErrorMsg(action.error) || getIn18Text('YIDONGWENJIANJIA');
        reduxMessage.error({ content: errorMsg });
    },
});
thunkHelper({
    name: 'deleteUserFolder',
    request: async (params, thunkAPI) => {
        var _a;
        const ids = (_a = params === null || params === void 0 ? void 0 : params.mailIds) !== null && _a !== void 0 ? _a : [];
        const { accountId } = params;
        const res = await MailApis.deleteUserFolder(ids, accountId);
        if (res) {
            reduxMessage.success({ content: getIn18Text('SHANCHUWENJIANJIA11') });
            thunkAPI.dispatch(Thunks.refreshFolder({ noCache: true, account: accountId }));
            return res;
        }
        reduxMessage.error({ content: getIn18Text('SHANCHUWENJIANJIA') });
        return {
            params,
        };
    },
    fulfilled: (state, action) => { },
    rejected: (state, action) => {
        const errorMsg = getFolderErrorMsg(action.error) || getIn18Text('SHANCHUWENJIANJIA');
        reduxMessage.error({ content: errorMsg });
    },
});
thunkHelper({
    name: 'doMailAllDelete',
    request: async (params, thunkAPI) => {
        const { rejectWithValue } = thunkAPI;
        const { fid, accountId } = params;
        if (fid != null) {
            const res = await MailApis.doDeleteMail({ fid, _account: accountId }).catch(r => rejectWithValue(r));
            if (res && res.succ) {
                const state = thunkAPI.getState().mailReducer;
                const tabState = thunkAPI.getState().mailTabReducer;
                const idArr = tabState.tabList
                    .map(m => m.id)
                    .filter(id => {
                    var _a;
                    const folder = (_a = state.mailEntities[id]) === null || _a === void 0 ? void 0 : _a.entry.folder;
                    return folder && folder == fid;
                });
                if (idArr && idArr.length) {
                    thunkAPI.dispatch(MailTabActions.doBatchCloseTab(idArr));
                }
                return res;
            }
            return rejectWithValue({ params, res });
        }
        return rejectWithValue({ params });
    },
    fulfilled: (state, action) => {
        const param = action.meta.arg;
        if (param != null && state.selectedKeys.id === param.fid) {
            state.mailDataList = [];
            state.mailTotal = 0;
            state.activeIds = [];
            const layout = mailConfApi.getMailPageLayout();
            if (layout !== '2') {
                state.selectedMailId = {
                    id: '',
                    accountId: '',
                };
            }
        }
        state.commonModalVisible = false;
    },
    rejected: (state, action) => {
        state.commonModalVisible = false;
        const { res } = action.payload;
        if (res && res.code === 'NETWORK.ERR') {
            reduxMessage.error({ content: getIn18Text('CAOZUOSHIBAI\uFF0C') });
        }
        else {
            reduxMessage.error({ content: getIn18Text('QINGKONGSHIBAI') });
        }
    },
});
thunkHelper({
    name: 'moveSortUserFolder',
    request: async (params, thunkAPI) => {
        const { dispatch, rejectWithValue } = thunkAPI;
        const { id, parent, sorts, accountId } = params;
        const reqParamsList = [
            {
                id: parent,
                sorts: sorts.join(','),
            },
        ];
        if (id > 0) {
            reqParamsList.unshift({
                id,
                parent,
            });
        }
        const res = await MailApis.updateUserFolder(reqParamsList, accountId);
        if (res) {
            return res;
        }
        return rejectWithValue();
    },
    pending: (state, action) => {
        const params = action.meta.arg;
    },
    fulfilled: (state, action) => {
        const { id, parent, sorts, accountId } = action.meta.arg;
        const res = action.payload;
        if (res && id) {
            const mailTreeState = getTreeStatesByAccount(state.mailTreeStateMap, accountId);
            if (mailTreeState && mailTreeState.mailFolderTreeList) {
                const newMailFolderTreeList = getMailFolderTreeList(mailTreeState.mailFolderTreeList, { id, parent, sorts });
                const newMailFolderTreeMap = getTreeId2Node(newMailFolderTreeList);
                const path = getTreeIdPathById(newMailFolderTreeList, id);
                if (isMainAccount(accountId)) {
                    state.mailTreeStateMap.main.mailFolderTreeList = newMailFolderTreeList;
                    state.mailTreeStateMap.main.MailFolderTreeMap = newMailFolderTreeMap;
                    if (path && path.length) {
                        state.mailTreeStateMap.main.expandedKeys = [...new Set([...state.mailTreeStateMap.main.expandedKeys, ...path])];
                    }
                }
                else {
                    state.mailTreeStateMap[accountId].mailFolderTreeList = newMailFolderTreeList;
                    state.mailTreeStateMap[accountId].MailFolderTreeMap = newMailFolderTreeMap;
                    if (path && path.length) {
                        state.mailTreeStateMap[accountId].expandedKeys = [...new Set([...state.mailTreeStateMap.main.expandedKeys, ...path])];
                    }
                }
            }
        }
    },
    rejected: (state, action) => {
        const { code } = action.error || {};
        const msg = folderOperErrCode2Msg(code);
        reduxMessage.error({ content: msg });
    },
});
thunkHelper({
    name: 'sortUserFolder',
    request: async (params, thunkAPI) => {
        const { dispatch, rejectWithValue } = thunkAPI;
        const { id, sorts, accountId } = params;
        const reqParamsList = [{ id, sorts: sorts.join(',') }];
        const res = await MailApis.updateUserFolder(reqParamsList, accountId);
        if (res) {
            setTimeout(() => {
                dispatch(Thunks.refreshFolder({ noCache: true }));
            }, 1500);
            return res;
        }
        return rejectWithValue();
    },
    pending: (state, action) => { },
    fulfilled: (state, action) => { },
    rejected: (state, action) => {
        reduxMessage.error({ content: getIn18Text('PAIXUSHIBAI') });
    },
});
thunkHelper({
    name: 'wmGuideSortUserFolder',
    request: async (params, thunkAPI) => {
        const state = thunkAPI.getState().mailReducer;
        const folderInfoMap = state.mailTreeStateMap;
        for (let i in folderInfoMap) {
            if (folderInfoMap[i]) {
                try {
                    const mailList = folderInfoMap[i].mailFolderTreeList;
                    const accountId = folderInfoMap[i].accountId;
                    const sortIds = getWmGuideSortFoldeIds(mailList);
                    const reqParamsList = [{ id: 0, sorts: sortIds.join(',') }];
                    const res = await MailApis.updateUserFolder(reqParamsList, accountId);
                }
                catch (e) {
                    console.warn('wmGuideSortUserFolder', e);
                }
            }
        }
    },
    pending: (state, action) => { },
    fulfilled: (state, action) => { },
    rejected: (state, action) => {
    },
});
thunkHelper({
    name: 'updateUserFolderAlias',
    request: async (params, thunkAPI) => {
        const { dispatch, rejectWithValue } = thunkAPI;
        const { account, name } = params;
        const res = await MailApis.updateDisplayEmail({ bindEmail: account, bindUserName: name });
        if (res) {
            return res;
        }
        return rejectWithValue();
    },
    pending: (state, action) => { },
    fulfilled: (state, action) => {
        const { account, name } = action.meta.arg;
        const res = action.payload;
        if (res) {
            state.mailAccountAliasMap[account] = name;
        }
    },
    rejected: (state, action) => {
        console.error('[updateUserFolderAlias Error reject]', action.error);
        reduxMessage.error({ content: getIn18Text('GENGXINZHANGHAONICSB') });
    },
});
thunkHelper({
    name: 'getUserFolderAlias',
    request: async (params, thunkAPI) => {
        const { dispatch, rejectWithValue } = thunkAPI;
        const { accountList } = params;
        if (accountList && accountList.length) {
            const res = await MailApis.getDisplayName(accountList);
            if (res) {
                return res;
            }
        }
        else {
            return {};
        }
        return rejectWithValue();
    },
    pending: (state, action) => { },
    fulfilled: (state, action) => {
        const res = action.payload;
        if (res) {
            if (res.bindUserDetail) {
                const map = {};
                for (let item of res.bindUserDetail) {
                    map[item.bindEmail] = item.bindUserName;
                }
                state.mailAccountAliasMap = map;
            }
        }
    },
    rejected: (state, action) => {
        console.error('[getUserFolderAlias Error reject]', action.error);
    },
});
export const FolderThunks = Thunks;
export const FolderExtraReducersList = ReducersList;
